import styled from "styled-components";
import { Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { theme } from "../../utils/globalStyles/colors";
import { fadeIn } from "../../utils/globalStyles/animations";

const DANGER = "#d93025";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding-bottom: 4px;
`;

export const Name = styled(Typography)`
  font-weight: 800 !important;
  color: #333333;
  font-size: 20px !important;
  text-align: center;
  word-break: break-word;
  margin-top: 4px !important;
`;

export const CodeButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  border-radius: 999px;
  background-color: #f2f3f5;
  color: #555555;
  padding: 8px 14px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease;

  &:active {
    transform: scale(0.96);
  }
`;

export const CopyIcon = styled(ContentCopyIcon)`
  font-size: 16px !important;
  color: #888888;
`;

export const CopiedIcon = styled(CheckIcon)`
  font-size: 16px !important;
  color: #28a745;
`;

export const CopyLabel = styled.span`
  font-size: 12px;
  color: #888888;
  font-weight: 600;
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 12px;
  animation: ${fadeIn} 0.2s ease-out both;
`;

const baseButton = `
  width: 100%;
  height: 50px;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.15s ease, background-color 0.2s ease;

  &:active {
    transform: scale(0.98);
  }
`;

export const PrimaryButton = styled.button`
  ${baseButton}
  background-color: ${theme.colors.base};
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(192, 90, 33, 0.25);
`;

export const SendIcon = styled(SendRoundedIcon)`
  font-size: 20px !important;
`;

export const TextDangerButton = styled.button`
  ${baseButton}
  background-color: transparent;
  color: ${DANGER};

  &:active {
    background-color: rgba(217, 48, 37, 0.08);
  }
`;

export const RemoveIcon = styled(PersonRemoveIcon)`
  font-size: 20px !important;
`;

/* Confirmação da remoção (no lugar dos botões) */
export const ConfirmBox = styled.div`
  width: 100%;
  margin-top: 12px;
  padding: 16px;
  border-radius: 14px;
  background-color: rgba(217, 48, 37, 0.06);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: ${fadeIn} 0.2s ease-out both;
`;

export const ConfirmText = styled(Typography)`
  color: #444444;
  font-size: 15px !important;
  text-align: center;
  word-break: break-word;
`;

export const ConfirmRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const SecondaryButton = styled.button`
  ${baseButton}
  flex: 1;
  height: 46px;
  background-color: #ffffff;
  color: #555555;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;

export const DangerButton = styled.button`
  ${baseButton}
  flex: 1;
  height: 46px;
  background-color: ${DANGER};
  color: #ffffff;
`;
